import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import AuthFlowFrame from "components/AuthFlowFrame";
import ProXtraPromotionalPanel from "components/ProXtraPromotionalPanel";
import ProXtraSignUpFooter from "components/ProXtraSignUpFooter";
import { useProXtraFlow } from "context";
import { formatPhoneForDisplay } from "helpers";
import StatusTitle from "./Step3-StatusTitle";

function Step3NoAccount() {
    const navigate = useNavigate();
    const { phoneNumber } = useProXtraFlow();
    const formattedPhone = formatPhoneForDisplay(phoneNumber);

    const description: ReactNode = (
        <>
            We couldn&apos;t find a Pro Xtra account with the phone number{" "}
            <strong>{formattedPhone}</strong>, please check the number and try
            again.
        </>
    );

    return (
        <AuthFlowFrame
            pretitle="Connect your Pro Xtra account"
            title={
                <StatusTitle
                    text="No account found"
                    iconName="alert"
                    variant="critical"
                />
            }
            description={description}
            sidePanel={<ProXtraPromotionalPanel />}
            secondaryButton={{
                text: "Start Over",
                onClick: () => navigate("/jobber-homedepot-step1"),
            }}
            footer={<ProXtraSignUpFooter />}
        />
    );
}

export default Step3NoAccount;
